import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { LoginStatus } from 'app/clases/login-status';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import swal from 'sweetalert2';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public loginEvent: EventEmitter<void>;
  constructor(private _client: HttpClient, private router: Router, private location: Location) {
    this.loginEvent = new EventEmitter<void>();
    this.logged = false;
  }
  public logged;

  /**
   * cerrarSesion
   */
  public cerrarSesion() {
    localStorage.clear();
    this.router.navigate(['/']);
  }

  async login(user, pass){
    let data;
    try{
      data = await this._client.post(`${environment.api}vital/login`, { user, pass }, {
        responseType: 'json'
      }).toPromise();
      if (!(data.usuario === undefined || data.usuario === null) ){
        if (data.usuario.estado === 0){
          swal.fire({
              title: 'Error',
              type: 'error',
              text: 'Tu usuario se encuentra deshabilitado'
          });
        }else{
          localStorage.setItem("token", data.token);
          localStorage.setItem("usuario", JSON.stringify(data.usuario));
          localStorage.setItem("permisos", JSON.stringify(data.permisos));
          this.router.navigate(['/']);
          window.location.reload();
        }
      }
    }catch (e){
      console.log(e);
      this.logged = false;
    }
    return data;
  }

  async loginStatus(){
    const data = await this._client.get<LoginStatus>(`${environment.backendUrl}/controllers/login_controller.php?accion=loginStatus`, {
      withCredentials: true
    }).toPromise();
    console.log(data);
    return data;
  }
}
